<template >
  <div class="head-wrapper">
    <img @click="goBack" src="../assets/back.png">
    <p class="title"> {{title}}</p>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import config from '@/config'
import moment from 'moment'

export default {
  props: {
    nosearch: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nowTime: moment().format('MM-DD HH:mm:ss')
    }
  },
  computed: {
    ...mapState(['status', 'code', 'market', 'stockname', 'symbol'])
  },
  created() {
    window.onscroll = null
  },
  methods: {
    goBack() {
      this.$router.push({
        path: `/${this.market}/${this.symbol}.html`,
      })
    },
  },
  filters: {
    getStatus(type) {
      return config.marketStatus[type]
    }
  }
}
</script>

<style lang="stylus" scoped>
.head-wrapper
  padding-top .1rem
  height .3rem
  position fixed
  width 100%
  top: 0
  text-align: center
  background linear-gradient(#FF2020, #F43737)
  color: #FFFFFF
  z-index 9999

.title
  font-size: .15rem

.sub-title
  font-size: .12rem
  margin-top .04rem
img 
  position absolute
  width 10px
  height 16px
  left .15rem
  bottom: .11rem
  size convert
</style>
